<span class="label" [class]="data?.icon" [style.--icon-color]="data?.iconColor" [style.--bg-color]="data?.iconBgColor">
  {{ data?.label }}
</span>
{{ data?.value }}
